type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'DishType'
const nameSource = 'commercial/dishesTypes'
const namePageTitle = 'Tipos de Item'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Tipos de item',
  to: '/commercial/dishesTypes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/dishesTypes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/dishesTypes/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/dishesTypes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
